import { idFromObject } from '@sorare/core/src/gql/idFromObject';

/**
 * The rate the UI quoted its price from. The backend validates this id so that
 * a user is never charged at a rate they were not shown: a bid's fiat amount is
 * computed client-side from it, and an accept's fiat charge is derived from it
 * server-side. `useRefreshExchangeRateOnOpen` keeps it current, before the user
 * commits.
 */
export const quotedExchangeRateId = (exchangeRate: { id: string }) =>
  idFromObject(exchangeRate.id);
